(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('m42DashboardWidgetCustom', {
		require: {
			gridsterItem: '^^gridsterItem',
		},
		bindings: {
			m42Params: '=',
			m42WidgetId: '=?',
		},
		controllerAs: 'vm',
		controller: M42DashboardWidgetCustomCtrl,
		template: '',
	});

	M42DashboardWidgetCustomCtrl.$inject = [
		'$element',
		'$compile',
		'$rootScope',
		'$scope',
		'mx.SolutionBuilderAgent.DashboardWidgetDataService',
		'mx.shell.ContextService',
		'mx.shell.EventService',
	];

	function M42DashboardWidgetCustomCtrl($element, $compile, $rootScope, $scope, dashboardDataService, contextService, eventService) {
		var vm = this;
		var localScope, contentNoTitleClass, contentTemplate;

		vm.$onInit = function () {
			vm.title = vm.m42Params.title;

			contentNoTitleClass = vm.title ? '' : ' widget-content-no-title ';

			vm.isDynamicHeight = vm.m42Params.class.indexOf('dynamic-height') >= 0;
			vm.isTransparentBackground = vm.m42Params.class.indexOf('transparent-background') >= 0;

			contentTemplate =
				'<div class="widget-title" ng-show="::vm.title" aria-level="2" title="' +
				vm.m42Params.title +
				'">' +
				vm.m42Params.title +
				'</div>' +
				'<div class="widget-content ' +
				contentNoTitleClass +
				(vm.m42Params.class || '') +
				'" style="' +
				(vm.m42Params.style || '') +
				'">' +
				dashboardDataService.getWidgetContent(vm.m42Params.dashboardId, vm.m42WidgetId) +
				'</div>';

			compile(contentTemplate);

			if (vm.isDynamicHeight) {
				vm.widgetContent = $element[0].querySelector('.widget-content');
				let oldSizeY = 0;
				var _handleResize = $.debounce(300, function () {
					if (!$(vm.widgetContent).is(':visible')) {
						return;
					}

					const height = vm.widgetContent.scrollHeight;
					if (!height) {
						_handleResize();
						return;
					}

					const borderSize = 2;
					const contentHeight = height; // - titleHeight;
					const firstRowHeight = 130 - borderSize; // - titleHeight; // 130 instead of 160 (as set in config) - some bug in gridster or in m42dashboard
					const rowHeightOption = 160; // 'default rowHeight of m42Dashboard' - sizeOfBorder - sizeIfTitle

					vm.gridsterItem.sizeY = contentHeight > firstRowHeight ? Math.floor((contentHeight - firstRowHeight - 1) / rowHeightOption) + 2 : 1;
					if (vm.gridsterItem.sizeY !== oldSizeY) {
						oldSizeY = vm.gridsterItem.sizeY;
						$scope.$evalAsync();
					}
				});
				eventService.subscribeTo(mx.shell.EventCodes.LayoutChanged, _handleResize, $scope);
				$scope.$watch(_handleResize);
				$scope.$evalAsync(function () {
					_handleResize();
				});
			}

			if (vm.isTransparentBackground) {
				if (vm.gridsterItem.$element) {
					vm.gridsterItem.$element.addClass('transparent-background');
				} else {
					var elementWatcher = $scope.$watch(
						function () {
							return vm.gridsterItem.$element;
						},
						function (element) {
							if (element) {
								vm.gridsterItem.$element.addClass('transparent-background');
							}
							elementWatcher();
						}
					);
				}
			}
		};

		function compile(tpl) {
			destroy();
			var _elem = angular.element(tpl);

			$element.append(_elem);

			localScope = $rootScope.$new(false, $scope);
			localScope.vm = {};

			localScope.vm.dataModel = contextService.val('SolutionBuilderAgent.LandingPageDataModel');
			localScope.vm.title = vm.m42Params.title;

			$compile(_elem)(localScope);
			$element.on('$destroy', destroy);
		}

		function destroy() {
			if (localScope) {
				localScope.$destroy();
				$element.empty();
			}
		}
	}
})();
